import { FilterDropdown } from '@ui';
import { useCSSchedulerFiltersStore } from '@lp/core/store/scheduler';
import { OrganType, OrganTypeWithoutKidney } from '@/api/apis/case';
import { getNameValuesFromEnumNames } from '@/utils/helpers';

// TMDXLP-14091: Kidneys hidden from Schedule organ filters below.
// To restore, swap every OrganTypeWithoutKidney/ScheduleFilterOrgan back to OrganType.
type ScheduleFilterOrgan = keyof typeof OrganTypeWithoutKidney;

export const OrganFiltersRow = () => {
  const filters = useCSSchedulerFiltersStore();

  return (
    <div className="flex items-center gap-4 justify-start w-full">
      <FilterDropdown
        title="Organ"
        mode="multiple"
        items={getNameValuesFromEnumNames(OrganTypeWithoutKidney)}
        selectedKeys={filters.organs as unknown as ScheduleFilterOrgan[]}
        onSelectedKeysChange={(organs) => filters.setFilterByKey('organs', organs as OrganType[])}
      />
      <FilterDropdown
        title="CL Organ"
        mode="multiple"
        items={getNameValuesFromEnumNames(OrganTypeWithoutKidney)}
        selectedKeys={filters.phoneSupportOrgans as unknown as ScheduleFilterOrgan[]}
        onSelectedKeysChange={(organs) => filters.setFilterByKey('phoneSupportOrgans', organs as OrganType[])}
      />
      <FilterDropdown
        title="Shadow Organ"
        mode="multiple"
        items={getNameValuesFromEnumNames(OrganTypeWithoutKidney)}
        selectedKeys={filters.shadowOrgans as unknown as ScheduleFilterOrgan[]}
        onSelectedKeysChange={(organs) => filters.setFilterByKey('shadowOrgans', organs as OrganType[])}
      />
      <FilterDropdown
        title="Proctor Organ"
        mode="multiple"
        items={getNameValuesFromEnumNames(OrganTypeWithoutKidney)}
        selectedKeys={filters.proctorOrgans as unknown as ScheduleFilterOrgan[]}
        onSelectedKeysChange={(organs) => filters.setFilterByKey('proctorOrgans', organs as OrganType[])}
      />
    </div>
  );
};
